export type IfscResponse = {
  BANK: string;
  IFSC: string;
  BRANCH: string;
  CITY?: string;
  STATE?: string;
  ADDRESS?: string;
  CONTACT?: string;
  MICR?: string;
  UPI?: boolean;
  RTGS?: boolean;
  NEFT?: boolean;
  IMPS?: boolean;
};

const IFSC_PATTERN = /^[A-Z]{4}0[A-Z0-9]{6}$/;

export function isLikelyIfsc(value: string): boolean {
  return IFSC_PATTERN.test(value);
}

export async function fetchIfsc(ifsc: string): Promise<IfscResponse | null> {
  const code = ifsc.trim().toUpperCase();
  if (!isLikelyIfsc(code)) return null;
  try {
    const res = await fetch(`https://ifsc.razorpay.com/${code}`);
    if (!res.ok) return null;
    return (await res.json()) as IfscResponse;
  } catch {
    return null;
  }
}
